/* eslint-disable import/prefer-default-export */

export function merge(...objects) {
	return Object.assign({}, ...objects);
}
